import { InvestmentProductRow } from './extensions/investmentProductRow';
import StarterKit from '@tiptap/starter-kit';
import TextAlign from '@tiptap/extension-text-align';
import { FontSize, TextStyle } from '@tiptap/extension-text-style';
import Color from '@tiptap/extension-color';
import Highlight from '@tiptap/extension-highlight';
import { TableKit } from '@tiptap-pro/extension-pages';
import { ResizableImage } from '@/editor/extensions/resizableImage';
import { VariableNode } from '@/editor/extensions/variableNode';
import { ListNumberPrefix } from '@/editor/extensions/listNumberPrefix';

/**
 * Extensions voor rich text binnen contentpagina / Plan van Aanpak (zelfde schema als in de editor).
 * Gebruikt door @tiptap/html generateHTML/generateJSON in blockConversion.
 */
export const sectionContentExtensions = [
  StarterKit.configure({
    heading: { levels: [1, 2, 3] },
    codeBlock: false,
    link: {
      openOnClick: false,
      HTMLAttributes: { class: 'text-primary underline' },
    },
  }),
  TextStyle,
  Color,
  FontSize,
  Highlight.configure({ multicolor: true }),
  TextAlign.configure({ types: ['heading', 'paragraph'] }),
  ListNumberPrefix,
  ResizableImage,
  VariableNode,
  InvestmentProductRow,
  TableKit.configure({
    tableRow: false,
    table: {
      resizable: false,
      lastColumnResizable: false,
      cellMinWidth: 72,
    },
  }),
];
